import { addMinutes, subMinutes } from "date-fns";
import { SLOT_TIME } from "../../appointment-schedule.constants.js";
const roundTime = (date, increment = false) => {
  const minutes = date.getMinutes();
  const rest = minutes % SLOT_TIME;
  const method = increment ? addMinutes : subMinutes;
  if (!rest)
    return date;
  return method(date, SLOT_TIME - rest);
};
export {
  roundTime
};
